import React, { useState } from "react";

const BackgroundImage: React.FC = () => {
  const [loaded, setLoaded] = useState(false);

  return (
    <div
      className="fixed inset-0 -z-10 w-full h-full bg-gray-100"
      style={{
        overflow: "hidden",
        height: "100vh",
      }}
    >
      <picture>
        <source
          media="(max-width: 640px)"
          srcSet={`${process.env.REACT_APP_PUBLIC_URL}/images/mobile/home.png`}
        />
        <img
          src={`${process.env.REACT_APP_PUBLIC_URL}/images/background.png`}
          alt="Background"
          className={`w-full h-full object-cover transition-opacity duration-700 ${loaded ? "opacity-100" : "opacity-0"}`}
          onLoad={() => setLoaded(true)}
          style={{
            objectFit: "cover",
            height: "100vh",
            width: "100vw",
          }}
        />
      </picture>
    </div>
  );
};

export default BackgroundImage;
